export default __webpack_public_path__ + "static/media/get-appstore.86aca20c.svg";